import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from 'app/App';
import reportWebVitals from 'reportWebVitals';
import store from 'store';

import './application.scss';

const createElementWithId = (type, id) => {
  const element = document.createElement(type);
  element.setAttribute('id', id);
  return element;
};

const root = ReactDOM.createRoot(document.body.appendChild(createElementWithId('div', 'root')));

if (window.location.pathname === '/design/best-of-preview') {
  import('app/features/BestOf/design/PreviewRuntime').then(({ startPreview }) =>
    startPreview(root)
  );
} else {
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );

  reportWebVitals();
}
